<template>
  <div>
    <div
      v-if="type==='text' || type === 'editor' || type === 'number' || type === 'email' || type === 'phone'"
      class="field-item-row field-item-c-i"
    >
      <div class="label">
        {{ $t('message["655"]') }}
      </div>
      <template>
        <div
          class="field-item-cell"
        >
          <a-input v-model="itemData.defaultvalue" />
        </div>
      </template>
    </div>
    <div
      v-else-if="type==='datetime'"
      class="field-item-row"
    >
      <div class="label">
        {{ $t('message["655"]') }}
      </div>
      <template>
        <div
          class="field-item-cell"
        >
          <template>
            <a-date-picker
              v-if="itemData.defaultvalue"
              :default-value="moment(itemData.defaultvalue)"
              class="date-picker"
              :format="dateFormat"
              :show-time="showTime"
              dropdown-class-name="my-data-picker"
              @change="onChangetime"
              @ok="onOk"
            />
            <a-date-picker
              v-else
              class="date-picker"
              :format="dateFormat"
              :show-time="showTime"
              dropdown-class-name="my-data-picker"
              @change="onChangetime"
              @ok="onOk"
            />
          </template>
          <a-checkbox
            v-model="itemData.fieldconfig.isnow"
          >
            {{ $t('message["166"]') }}
          </a-checkbox>
        </div>
      </template>
    </div>
    <div
      v-else-if="type==='area'"
      class="field-item-row"
    >
      <div class="label">
        {{ $t('message["655"]') }}
      </div>
      <template>
        <div
          class="field-item-cell"
        >
          <area-item :data="itemData" />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AreaItem from './Area'
import moment from 'moment'
export default {
  components: {
    AreaItem
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapState('universalForm/form', ['infoDatas', 'formDefaultDatas']),
    showTime () {
      const { fieldconfig = {} } = this.itemData || {}
      const { formatdatetime } = fieldconfig
      if (formatdatetime === 1) {
        return false
      }
      return true
    },
    dateFormat () {
      if (!this.showTime) {
        return 'YYYY-MM-DD'
      } else {
        return 'YYYY-MM-DD HH:mm'
      }
    },
    type () {
      return this.itemData.fieldtype
    }
  },
  methods: {
    moment,
    onChange () {
    },
    onOk () {},
    onChangetime (d, datestring) {
      this.itemData.defaultvalue = datestring
    }
  }
}
</script>
